"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CopyLink = _interopRequireDefault(require("../CopyLink.vue"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _store = require("@/api/store");
var _config = require("./config");
var _api = require("../../../api");
var _amount = require("@/utils/amount");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponDetail',
  components: {
    CopyLinkVue: _CopyLink.default
  },
  data: function data() {
    return _objectSpread(_objectSpread({}, (0, _paginationEffect.default)(this.handlerGetListData)), {}, {
      tableConfig: _config.tableConfig,
      applicableProducts: [],
      showTableData: {
        list: [],
        total: 0
      },
      loading: false,
      form: {
        distributionCustomers: [],
        couponDiscount: [{}],
        status: 0,
        // 默认状态
        voucherType: 1,
        // 券类型，默认为优惠券
        rangeConfig: null // 范围配置
      },
      ID: null,
      showCateIdOption: [],
      productTypeOptions: [],
      // 产品类型选项（可使用场景）
      // 范围配置选项数据（用于显示名称）
      rangeConfigOptions: {
        selfOperatedCardVouchers: [],
        onlineOrderingBrands: [],
        verificationStoresMerchants: [],
        verificationStores: [],
        gasStationStores: [],
        renshouMerchants: [],
        renshouStores: []
      }
    });
  },
  computed: {
    hasRangeConfig: function hasRangeConfig() {
      if (!this.form.rangeConfig) return false;
      try {
        var config = typeof this.form.rangeConfig === 'string' ? JSON.parse(this.form.rangeConfig) : this.form.rangeConfig;
        return Object.values(config).some(function (arr) {
          return Array.isArray(arr) && arr.length > 0;
        });
      } catch (e) {
        return false;
      }
    }
  },
  created: function created() {
    var id = this.$route.path.split('/').pop();
    this.ID = id;
    this.getDetail(id);
    this.getCategorySelect();
    this.loadProductTypeDict();
  },
  methods: {
    getDetail: function () {
      var _getDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              this.request(_api.detailCouponsApi, id, function (res) {
                _this.handleInfo(res);
                _this.loading = false;
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    handleInfo: function handleInfo(res) {
      var _res$distributionCust, _res$distributionCust2;
      this.form = res;
      this.$set(this.form, 'receiveTime', [res.startTime, res.endTime]);
      this.$set(this.form, 'lifespanTime', [res.validityStart, res.validityEnd]);
      this.$set(this.form, 'distributionCustomers', (_res$distributionCust = res.distributionCustomers) === null || _res$distributionCust === void 0 ? void 0 : (_res$distributionCust2 = _res$distributionCust.split(',')) === null || _res$distributionCust2 === void 0 ? void 0 : _res$distributionCust2.map(function (j) {
        return Number(j);
      }));

      // 处理优惠信息
      if (res.couponDiscount) {
        try {
          if (typeof res.couponDiscount === 'string') {
            this.form.couponDiscount = JSON.parse(res.couponDiscount);
          } else {
            this.form.couponDiscount = res.couponDiscount;
          }
        } catch (e) {
          console.error('解析优惠信息失败:', e);
          this.form.couponDiscount = [{}];
        }
      }

      // 处理范围配置
      if (res.rangeConfig) {
        try {
          if (typeof res.rangeConfig === 'string') {
            this.form.rangeConfig = JSON.parse(res.rangeConfig);
          } else {
            this.form.rangeConfig = res.rangeConfig;
          }
          // 加载范围配置的名称
          this.loadRangeConfigNames();
        } catch (e) {
          console.error('解析范围配置失败:', e);
          this.form.rangeConfig = null;
        }
      }

      // 处理可使用场景
      if (res.usableScenarios) {
        try {
          if (typeof res.usableScenarios === 'string') {
            this.form.usableScenarios = JSON.parse(res.usableScenarios);
          }
        } catch (e) {
          console.error('解析可使用场景失败:', e);
          this.form.usableScenarios = [];
        }
      }
      res.applicableRangeType !== 1 && this.updateTableData(res.productAttrValueList);
      console.log('优惠券详情:', res);
    },
    // 获取状态类型
    getStatusType: function getStatusType(status) {
      var types = {
        0: 'info',
        // 未开始
        1: 'success',
        // 进行中
        2: 'warning',
        // 已暂停
        3: 'danger' // 已结束
      };
      return types[status] || 'info';
    },
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      var texts = {
        0: '未开始',
        1: '进行中',
        2: '已暂停',
        3: '已结束'
      };
      return texts[status] || '未知状态';
    },
    // 获取状态图标
    getStatusIcon: function getStatusIcon(status) {
      var icons = {
        0: 'el-icon-time',
        // 未开始
        1: 'el-icon-success',
        // 进行中
        2: 'el-icon-warning',
        // 已暂停
        3: 'el-icon-circle-close' // 已结束
      };
      return icons[status] || 'el-icon-question';
    },
    updateTableData: function updateTableData() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.applicableProducts = _toConsumableArray(list);
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var start = (this.pageData.page - 1) * this.pageData.limit;
      var end = start + this.pageData.limit;
      this.showTableData.list = this.applicableProducts.slice(start, end);
      this.$set(this.showTableData, 'total', this.applicableProducts.length);
    },
    //  请求工具函数
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(api, params, callback) {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              api(params).then(function (res) {
                callback(res);
                _this2.loading = false;
              }).catch(function (err) {
                _this2.loading = false;
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function request(_x2, _x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    copyLink: function copyLink() {
      this.$refs.CopyLinkVueRef.open(this.ID);
    },
    // 获取分类
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.showCateIdOption = _this3.addDisabled(res);
      });
    },
    // 限制商品分类只能选择开启的
    addDisabled: function addDisabled() {
      var _this4 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      try {
        arr.forEach(function (e) {
          var e_new = _objectSpread(_objectSpread({}, e), {}, {
            disabled: !e.status
          });
          if (e.child) {
            var childList = _this4.addDisabled(e.child);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              child: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        console.log("\u5904\u7406\u5206\u7C7B\u4FE1\u606F\u51FA\u73B0\u9519\u8BEF\uFF01----".concat(error));
      }
      return list;
    },
    // 格式化领用规则
    formatLimitRule: function formatLimitRule(limitType, limitQuantity) {
      if (!limitType || !limitQuantity) return '--';
      switch (limitType) {
        case 1:
          return "\u6BCF\u4EBA\u9650\u9886".concat(limitQuantity, "\u5F20");
        case 2:
          return "\u6BCF\u4EBA\u6BCF\u5929\u9650\u9886".concat(limitQuantity, "\u5F20");
        default:
          return '--';
      }
    },
    formatAmount: function formatAmount(value) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$withUnit = _ref.withUnit,
        withUnit = _ref$withUnit === void 0 ? true : _ref$withUnit;
      if (value === null || value === undefined || value === '') return '--';
      var formatted = (0, _amount.formatToYuan)(value, {
        showUnit: false,
        fractionDigits: 2
      });
      return withUnit ? "".concat(formatted, "\u5143") : formatted;
    },
    // 格式化优惠方式
    formatCouponType: function formatCouponType(couponType) {
      var types = {
        1: '满减',
        2: '折扣'
      };
      return types[couponType] || '--';
    },
    // 格式化优惠信息
    formatDiscountInfo: function formatDiscountInfo(couponDiscount, couponType) {
      var _this5 = this;
      if (!couponDiscount || !Array.isArray(couponDiscount) || couponDiscount.length === 0) {
        return [];
      }
      return couponDiscount.filter(function (item) {
        return item && (item.threshold || item.discount);
      }).map(function (item) {
        var threshold = item.threshold || 0;
        var discount = item.discount || 0;
        if (couponType === 2) {
          // 折扣
          var thresholdUnit = item.thresholdType === 2 ? '件' : '元';
          return "\u6EE1".concat(threshold).concat(thresholdUnit, "\uFF0C\u6253").concat(discount, "\u6298");
        } else {
          // 满减
          var thresholdText = _this5.formatAmount(threshold, {
            withUnit: false
          });
          var discountText = _this5.formatAmount(discount, {
            withUnit: false
          });
          return "\u6EE1".concat(thresholdText, "\u5143\uFF0C\u51CF").concat(discountText, "\u5143");
        }
      });
    },
    // 格式化地区限制（显示摘要）
    formatAreaRestriction: function formatAreaRestriction(areaRestrictionScope) {
      if (!areaRestrictionScope) return '--';
      try {
        var areaData = typeof areaRestrictionScope === 'string' ? JSON.parse(areaRestrictionScope) : areaRestrictionScope;

        // 支持数组格式（新格式）：[{"province":"四川","city":"成都市","district":"高新西区"},...]
        if (Array.isArray(areaData) && areaData.length > 0) {
          // 如果只有一个地区，直接显示
          if (areaData.length === 1) {
            var area = areaData[0];
            var _parts = [area.province, area.city, area.district].filter(Boolean);
            return _parts.join(' / ') || '--';
          }
          // 如果有多个地区，显示第一个并标注总数
          var firstArea = areaData[0];
          var parts = [firstArea.province, firstArea.city, firstArea.district].filter(Boolean);
          var firstPart = parts.join(' / ') || '--';
          return "".concat(firstPart, " \u7B49 ").concat(areaData.length, " \u4E2A\u5730\u533A");
        }

        // 支持旧格式：单个对象 {"province":"四川","city":"成都市","district":"高新西区"}
        if (areaData && _typeof(areaData) === 'object' && !Array.isArray(areaData)) {
          var _parts2 = [areaData.province, areaData.city, areaData.district].filter(Boolean);
          return _parts2.join(' / ') || '--';
        }
        return '--';
      } catch (e) {
        console.error('解析地区限制失败:', e);
        return '--';
      }
    },
    // 获取地区限制列表（用于显示所有地区）
    getAreaRestrictionList: function getAreaRestrictionList(areaRestrictionScope) {
      if (!areaRestrictionScope) return [];
      try {
        var areaData = typeof areaRestrictionScope === 'string' ? JSON.parse(areaRestrictionScope) : areaRestrictionScope;

        // 支持数组格式（新格式）
        if (Array.isArray(areaData) && areaData.length > 0) {
          return areaData.map(function (area) {
            var parts = [area.province, area.city, area.district].filter(Boolean);
            return parts.join(' / ');
          }).filter(Boolean);
        }

        // 支持旧格式：单个对象
        if (areaData && _typeof(areaData) === 'object' && !Array.isArray(areaData)) {
          var parts = [areaData.province, areaData.city, areaData.district].filter(Boolean);
          return parts.length > 0 ? [parts.join(' / ')] : [];
        }
        return [];
      } catch (e) {
        console.error('解析地区限制列表失败:', e);
        return [];
      }
    },
    // 加载产品类型字典
    loadProductTypeDict: function () {
      var _loadProductTypeDict = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _api.getProductTypeDictApi)();
            case 1:
              res = _context3.v;
              this.productTypeOptions = res || [];
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              console.error('加载商品类型字典失败:', _t);
              this.productTypeOptions = [];
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadProductTypeDict() {
        return _loadProductTypeDict.apply(this, arguments);
      }
      return loadProductTypeDict;
    }(),
    // 获取可使用场景列表
    getUsableScenariosList: function getUsableScenariosList(usableScenarios) {
      var _this6 = this;
      if (!usableScenarios) return [];
      try {
        var scenarios = typeof usableScenarios === 'string' ? JSON.parse(usableScenarios) : usableScenarios;
        if (!Array.isArray(scenarios)) return [];

        // 根据产品类型字典显示名称
        return scenarios.map(function (code) {
          var option = _this6.productTypeOptions.find(function (opt) {
            return opt.code === code;
          });
          return option ? option.value : "\u573A\u666F".concat(code);
        }).filter(Boolean);
      } catch (e) {
        console.error('解析可使用场景失败:', e);
        return [];
      }
    },
    getUsableScenariosText: function getUsableScenariosText(usableScenarios) {
      return this.getUsableScenariosList(usableScenarios).length > 0;
    },
    // 获取范围配置项
    getRangeConfigItem: function getRangeConfigItem(key) {
      if (!this.form.rangeConfig) return [];
      try {
        var config = typeof this.form.rangeConfig === 'string' ? JSON.parse(this.form.rangeConfig) : this.form.rangeConfig;

        // 特殊处理 renshouStores：同时检查 renshouMerchantsStores（新字段）和 renshouStores（旧字段，向后兼容）
        var ids = [];
        if (key === 'renshouStores') {
          ids = config.renshouMerchantsStores || config.renshouStores || [];
        } else {
          ids = config[key] || [];
        }
        if (!Array.isArray(ids) || ids.length === 0) return [];

        // 从缓存的选项数据中获取名称
        var options = this.rangeConfigOptions[key] || [];
        return ids.map(function (id) {
          // 确保ID类型一致进行比较
          var idNum = typeof id === 'string' ? parseInt(id, 10) : id;
          var option = options.find(function (opt) {
            var optIdNum = typeof opt.id === 'string' ? parseInt(opt.id, 10) : opt.id;
            return optIdNum === idNum;
          });
          return option ? option.name : "ID: ".concat(id);
        });
      } catch (e) {
        console.error("\u83B7\u53D6\u8303\u56F4\u914D\u7F6E\u9879".concat(key, "\u5931\u8D25:"), e);
        return [];
      }
    },
    // 加载范围配置的名称（异步加载，如果API可用）
    loadRangeConfigNames: function () {
      var _loadRangeConfigNames = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this7 = this;
        var config, loadTasks, renshouStoreIds, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.form.rangeConfig) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.p = 1;
              config = typeof this.form.rangeConfig === 'string' ? JSON.parse(this.form.rangeConfig) : this.form.rangeConfig; // 并行加载所有需要的数据
              loadTasks = []; // 加载自营卡券商品
              if (config.selfOperatedCardVouchers && Array.isArray(config.selfOperatedCardVouchers) && config.selfOperatedCardVouchers.length > 0) {
                loadTasks.push((0, _api.getSelfOperatedCardProductsApi)().then(function (res) {
                  _this7.rangeConfigOptions.selfOperatedCardVouchers = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载自营卡券商品失败:', err);
                }));
              }

              // 加载在线点餐品牌
              if (config.onlineOrderingBrands && Array.isArray(config.onlineOrderingBrands) && config.onlineOrderingBrands.length > 0) {
                loadTasks.push((0, _api.getMealBrandsApi)().then(function (res) {
                  _this7.rangeConfigOptions.onlineOrderingBrands = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载在线点餐品牌失败:', err);
                }));
              }

              // 加载核销门店商家
              if (config.verificationStoresMerchants && Array.isArray(config.verificationStoresMerchants) && config.verificationStoresMerchants.length > 0) {
                loadTasks.push((0, _api.getVerificationMerchantsApi)().then(function (res) {
                  _this7.rangeConfigOptions.verificationStoresMerchants = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载核销门店商家失败:', err);
                }));
              }

              // 加载核销门店
              if (config.verificationStores && Array.isArray(config.verificationStores) && config.verificationStores.length > 0) {
                loadTasks.push((0, _api.getVerificationStoresApi)().then(function (res) {
                  _this7.rangeConfigOptions.verificationStores = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载核销门店失败:', err);
                }));
              }

              // 加载加油门店（使用核销门店API，可能需要过滤）
              if (config.gasStationStores && Array.isArray(config.gasStationStores) && config.gasStationStores.length > 0) {
                loadTasks.push((0, _api.getVerificationStoresApi)().then(function (res) {
                  _this7.rangeConfigOptions.gasStationStores = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载加油门店失败:', err);
                }));
              }

              // 加载仁寿网店商家（使用仁寿商家API，只查询有网店的商家）
              if (config.renshouMerchants && Array.isArray(config.renshouMerchants) && config.renshouMerchants.length > 0) {
                loadTasks.push((0, _api.getRenshouMerchantsApi)().then(function (res) {
                  _this7.rangeConfigOptions.renshouMerchants = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载仁寿网店商家失败:', err);
                }));
              }

              // 加载仁寿门店（使用仁寿门店API）
              // 同时检查 renshouMerchantsStores（新字段）和 renshouStores（旧字段，向后兼容）
              renshouStoreIds = config.renshouMerchantsStores || config.renshouStores || [];
              if (Array.isArray(renshouStoreIds) && renshouStoreIds.length > 0) {
                loadTasks.push((0, _api.getRenshouStoresApi)().then(function (res) {
                  _this7.rangeConfigOptions.renshouStores = (res || []).map(function (item) {
                    return {
                      id: item.key !== undefined ? item.key : item.id !== undefined ? item.id : null,
                      name: item.value !== undefined ? item.value : item.name !== undefined ? item.name : '未知'
                    };
                  }).filter(function (item) {
                    return item.id !== null;
                  });
                }).catch(function (err) {
                  console.error('加载仁寿门店失败:', err);
                }));
              }

              // 等待所有加载完成
              _context4.n = 2;
              return Promise.all(loadTasks);
            case 2:
              // 强制更新视图
              this.$forceUpdate();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              console.error('加载范围配置名称失败:', _t2);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function loadRangeConfigNames() {
        return _loadRangeConfigNames.apply(this, arguments);
      }
      return loadRangeConfigNames;
    }()
  }
};